export default __webpack_public_path__ + "static/media/outdated-incentives.787400da.png";